module.exports = __webpack_public_path__ + "img/1b992c9.webp";